import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { Stack } from 'react-bootstrap';
import { useAssessmentsDataContext } from '../../providers/assessments-data-provider';

function SelfPacedNav({ currentPage, maxPage, onNavClick }) {
  const { pageQuestionsAnswered, buttonsDisabled = false } = useAssessmentsDataContext();
  const [submitButton, setSubmitButton] = useState('Next');

  useEffect(() => {
    if (currentPage >= maxPage) {
      setSubmitButton('Submit');
    } else {
      setSubmitButton('Next');
    }
  }, [currentPage, maxPage]);

  return (
    <div className="d-flex w-100 mx-auto">
      <Stack className="align-items-center mb-5">
        <Button
          className="btn-assessment-primary mb-2"
          style={{ width: '125px' }}
          disabled={!pageQuestionsAnswered || buttonsDisabled}
          onClick={(event) => onNavClick(event, true)}
        >
          {submitButton}
        </Button>
        <Button
          className="btn-questions-back"
          style={{ width: '125px' }}
          disabled={currentPage <= 0 || buttonsDisabled}
          onClick={(event) => onNavClick(event, false)}
        >
          Go back
        </Button>
      </Stack>
    </div>
  );
}

export default SelfPacedNav;
